import { Hint } from "react-ui";
import * as React from "react";

import { Icon } from "../../Icons/Icon";

import { BaseCard, TextInCard } from "./FormInfo.styles";
import { htmlWithLinkToTextOrNode } from "./ActualInfoAboutForm";
import { bannerMaxWidth } from "./LinkInfo";

export interface PeriodBeginNewProps {
    periodBeginNew: string | undefined;
}

export const PeriodBeginNew = (props: PeriodBeginNewProps) => {
    const splitPeriodBeginNew = props.periodBeginNew?.split("|");

    return (
        <Hint
            text={htmlWithLinkToTextOrNode(splitPeriodBeginNew?.[1] ? <div>{splitPeriodBeginNew?.[1]}</div> : "")}
            pos={"bottom left"}
            maxWidth={bannerMaxWidth}
            useWrapper={true}>
            <BaseCard
                style={{
                    padding: "2px 0",
                }}>
                <Icon name={"TimeClockMoveBackIcon"} />
                <TextInCard>{splitPeriodBeginNew?.[0]}</TextInCard>
            </BaseCard>
        </Hint>
    );
};
